/*
 * OAF – Deposit clarity (product pages)
 * - Shows the live dollar amount on the Downpay purchase options:
 *     "30% deposit · $550.80 today"   /   "Pay in full · $1,836.00 today"
 * - Rewrites the help line under the options in plain English. The balance is billed
 *   manually when the furniture is picked up by the shipper, so no date is shown.
 * - Adds a short note above Shopify's required "deferred, subscription, or recurring"
 *   consent text (the consent text itself is left untouched).
 * Total price is read from the theme price element that DPO keeps updated with options.
 */
(function () {
  "use strict";

  var NOTE_ID = "oaf-deposit-consent-note";
  var INFO_ID = "oaf-po-info";

  function money(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
  }

  function totalCents() {
    var root = document.querySelector(".oaf-price-breakdown [id^='price-']") || document.querySelector("[id^='price-template']");
    if (!root) return null;
    var el = root.querySelector(".price--on-sale .price-item--sale") || root.querySelector(".price__regular .price-item--regular");
    if (!el) return null;
    var n = Math.round(Number(el.textContent.replace(/[^0-9.\-]/g, "")) * 100);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function depositPercent(label) {
    var m = label && label.textContent.match(/(\d+(?:\.\d+)?)\s*%/);
    return m ? Number(m[1]) : null;
  }

  function setAmount(label, text) {
    if (!label) return;
    var span = label.querySelector(".oaf-po-amount");
    if (!span) {
      span = document.createElement("span");
      span.className = "oaf-po-amount";
      label.appendChild(span);
    }
    if (span.textContent !== text) span.textContent = text;
  }

  var busy = false;
  function update() {
    if (busy) return;
    busy = true;
    try {
      var depWrap = document.getElementById("purchase-option-deposit-wrapper");
      var depLabel = document.querySelector("label[for='purchase-option-deposit-input']");
      var fullLabel = document.querySelector("label[for='purchase-option-full']");
      var total = totalCents();
      var pct = depositPercent(depLabel);
      if (!depWrap || !total || !pct) return;

      var deposit = Math.round(total * pct / 100);
      setAmount(depLabel, " · " + money(deposit) + " today");
      setAmount(fullLabel, " · " + money(total) + " today");

      // Downpay removes its own help line when "Pay in full" is chosen, so keep our own line
      // in the same spot (Downpay's line is hidden by CSS below).
      var depInput = document.getElementById("purchase-option-deposit-input");
      var infoWrap = document.getElementById("purchase-option-info-wrapper");
      if (infoWrap) {
        var mine = document.getElementById(INFO_ID);
        if (!mine) {
          mine = document.createElement("p");
          mine.id = INFO_ID;
          mine.className = "downpay-customer-info";
        }
        if (mine.parentNode !== infoWrap) infoWrap.appendChild(mine);
        var text = depInput && depInput.checked
          ? "Pay " + money(deposit) + " today. The remaining balance, plus shipping and tax, is charged once when your furniture is finished and picked up for delivery."
          : "You'll pay the full price today. Shipping and tax are added at checkout.";
        if (mine.textContent !== text) mine.textContent = text;
      }

      var consent = document.getElementById("shopify-buyer-consent");
      if (consent && !document.getElementById(NOTE_ID)) {
        var note = document.createElement("p");
        note.id = NOTE_ID;
        note.textContent = "Deposit orders are a one-time purchase, not a subscription. The notice below is Shopify's standard wording for orders with a later balance payment.";
        consent.parentNode.insertBefore(note, consent);
      }
    } finally {
      busy = false;
    }
  }

  var css = document.createElement("style");
  css.textContent =
    ".oaf-po-amount{font-weight:700;white-space:nowrap}" +
    "#hypehound-customer-info{display:none!important}" +
    "#" + NOTE_ID + "{margin:.6rem 0 .3rem;font-size:13px;line-height:1.45;color:#3d3528;font-weight:600}";
  document.head.appendChild(css);

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; update(); }, 60);
  }

  document.addEventListener("change", schedule);
  document.addEventListener("click", function (e) {
    if (e.target instanceof Element && e.target.closest("#downpay-product-wrapper")) schedule();
  });
  new MutationObserver(function (records) {
    // ignore our own edits
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || !(el.closest(".oaf-po-amount") || el.closest("#" + INFO_ID) || el.id === NOTE_ID)) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  schedule();
})();
